import React from "react";
import AMobileListForm from "./aMobileListForm";
import MobileLocalBookingStorageDataForm from "./mobileLocalBookingStorageDataForm";
import LocalBookingStorageAccess from "../../../services/database/localBookingStorageAccess";
import {dataToServerTable} from "../../../config.json";

class MobileLocalBookingStorageListForm extends AMobileListForm {
    availableModes = {
        list: true,
        show: true,
        delete: true
        // deleteAll: true
    };
    tableDefinition = [
        {header: "Id", field: "id", width: 75},
        {header: "URL", field: "url"},
        {
            header: "Table",
            field: "table"
        }
    ];

    getMobileDataForm = () => {
        return <MobileLocalBookingStorageDataForm/>;
    };

    loadAllData = async () => {
        let dataList = [];
        const {database} = this.props;
        if (database) {
            this.recordList = await LocalBookingStorageAccess.getAll(
                database,
                dataToServerTable
            );
            if (this.recordList && this.recordList.length > 0) {
                for (const record of this.recordList) {
                    const recordData = JSON.parse(record.recordData);
                    dataList.push({
                        id: record.id,
                        url: record.url,
                        table: recordData.table
                    });
                }
            }
        }
        this.setState({dataList});
    };

    delete = async id => {
        const {database} = this.props;
        if (database) {
            await LocalBookingStorageAccess.deleteById(
                database,
                dataToServerTable,
                id
            );
        }
        await this.loadAllData();
        this.setListMode();
    };

    deleteAll = async () => {
        const {database, pushNewMenu, flowChart} = this.props;
        if (database) {
            const recordList = await LocalBookingStorageAccess.getAll(
                database,
                dataToServerTable
            );
            if (recordList && recordList.length > 0) {
                for (const record of recordList) {
                    await LocalBookingStorageAccess.deleteById(
                        database,
                        dataToServerTable,
                        record.id
                    );
                }
            }
        }
        pushNewMenu({
            level: [],
            flowChart: flowChart
        });
    };
}

export default MobileLocalBookingStorageListForm;
